








	import Vue from 'vue';
    import NeuerTerminComp from "../../components/raid/NeuerTerminComp.vue";

    export default Vue.extend({
        name: "NeuerTerminPage",
        components: {NeuerTerminComp},
        computed: {
            showNeuerTermin: function(): boolean {
                return this.$vStore.getters.raidRole > 0;
            }
        }
    })
